import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Title, Micro } from "@vds/typography";
import { Loader } from "@vds/loaders";
import { FlexRow, FlexColumn, Wrapper, AccountProfile, CustomisedTitle } from "../constants/common/StyledGlobalConstants";
import "../App.css";
import * as account from "../api/account/index";
import { connect } from "react-redux";
import { getAlertState, setAlertState } from "../util/util";
import * as GlobalActions from "../store/actions/global/global";
import FailedToLoadData from "../pages/Login/failedToLoadData";
import { useTranslation } from "react-i18next";
import { pendoTrack } from "../util/pendoUtil";
import { chatDisplayHandler } from "../util/chatBotUtils";
import "../../src/constants/common/StyleOnlyForScreenReader.css";
import PropTypes from "prop-types";

const MarginWrapper = styled.div`
  margin-top: 0.2em;
  margin-bottom: 0.2em;
`;
export const SmallText = (props) => (
  <MarginWrapper>
    <Micro primitive="p" {...props}></Micro>
  </MarginWrapper>
);
function ManagePrimaryAccount(props) {
  const [loader, setLoader] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [contactPhoneNumber, setContactPhoneNumber] = useState("");
  const [editField] = useState({
    editEmail: false,
    editPhone: false,
    editAddress: false,
  });
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    title: "",
  });
  const [t] = useTranslation("accountTranslation");
  const titleRef = useRef(null);

  useEffect(() => {
    if (props.title) {
      document.title = props.title;
    }
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [props.title]);

  useEffect(() => {
    loadPrimaryAccountDetails();
  }, []);
  useEffect(() => {
    if (notification.show === true) {
      setTimeout(() => setNotification({ show: false, type: "", title: "" }), 5000);
    }
  }, [notification]);

  useEffect(() => {
    if (editField.editPhone === true) {
      document.getElementById("editPhoneNumberRef").focus();
    } else if (editField.editAddress === true) {
      document.getElementById("EditAddressRef").focus();
    }
  }, [editField.editPhone, editField.editAddress]);

  const loadPrimaryAccountDetails = async () => {
    setAlertState(false);
    setLoader(true);
    let responseArray = [];
    try {
      let reqBody = {
        accId: props.accountId,
      };
      responseArray = await account.getPrimaryAccountDetailsCall(reqBody);
      setLoader(false);

      if (responseArray.data.statusCode === "200" && responseArray.data.data.length != 0) {
        responseArray = [...responseArray.data.data];
        setCompanyName(responseArray[0].companyName);
        setAccountNumber(responseArray[0].accountNo);
        setBillingAddress(
          responseArray[0].billingAddress.street +
            ", " +
            responseArray[0].billingAddress.city +
            ", " +
            responseArray[0].billingAddress.state +
            ", " +
            responseArray[0].billingAddress.country +
            "," +
            responseArray[0].billingAddress.postalCode
        );
        setContactPhoneNumber(responseArray[0].phone);
      }
    } catch (err) {
      console.log("error", err);
      if (getAlertState() === false) {
        setAlertState(true);
        pendoTrack("Customer Portal | Account Profile | Failed To Load ", {
          status: "Unable to load data for account profile",
          statusCode: err.response.data.statusCode,
          accountId: props.accountNumber,
        });
      }
      setLoader(false);
    }
    return responseArray;
  };

  useEffect(() => {
    chatDisplayHandler(sessionStorage.getItem("currentPath"));
  }, []);

  return (
    <AccountProfile>
      {getAlertState() ? (
        <>
          <h1 className="sr-only" tabIndex="-1" ref={titleRef}>
            {"Account profile"}
          </h1>
          <FailedToLoadData title={t("Account profile")} />
        </>
      ) : (
        <>
          <CustomisedTitle fontSize="40px" lineHeight="48px" tabIndex="-1" aria-hidden="true">
            <h1 className="sr-only" tabIndex="-1" ref={titleRef}>
              {"Account profile"}
            </h1>
            <Title tabIndex="-1" aria-hidden="true" size="large">
              {t("Account profile")}
            </Title>
          </CustomisedTitle>
          <Loader active={loader} fullscreen={true} />
          <Wrapper
            display={"flex"}
            flexDirection={"column"}
            flexWrap={"nowrap"}
            width="100%"
            marginTop={"4rem"}
            padding="10px"
            id="account-profile-wrapper"
          >
            <FlexRow className="row1">
              <FlexColumn className="column1" tabIndex="-1">
                <Wrapper lineHeight="20px" fontStyle="normal" fontSize={"0.875rem"} bold fontFamily>
                  {t("Company name")}
                </Wrapper>
                <Wrapper
                  lineHeight="20px"
                  fontStyle="normal"
                  fontSize={"0.875rem"}
                  size="large"
                  marginTop={"0.25rem"}
                  overFlowWrap={"anywhere"}
                  fontFamily
                >
                  {companyName}
                </Wrapper>
              </FlexColumn>
              <FlexColumn className="column2" tabIndex="-1">
                <Wrapper lineHeight="20px" fontStyle="normal" fontSize={"0.875rem"} bold fontFamily>
                  {t("Account number")}
                </Wrapper>
                <Wrapper
                  lineHeight="20px"
                  fontStyle="normal"
                  fontSize={"0.875rem"}
                  size="large"
                  marginTop={"0.25rem"}
                  overFlowWrap={"anywhere"}
                  fontFamily
                >
                  {accountNumber}
                </Wrapper>
              </FlexColumn>
            </FlexRow>
            <FlexRow className="row2">
              <FlexColumn className="column1" tabIndex="-1">
                <Wrapper lineHeight="20px" fontStyle="normal" fontSize={"0.875rem"} bold fontFamily>
                  {t("Phone number")}
                </Wrapper>
                <Wrapper
                  lineHeight="20px"
                  fontStyle="normal"
                  fontSize={"0.875rem"}
                  size="large"
                  marginTop={"0.25rem"}
                  overFlowWrap={"anywhere"}
                  fontFamily
                >
                  {contactPhoneNumber}
                </Wrapper>
              </FlexColumn>
              <FlexColumn className="column2" tabIndex="-1">
                <Wrapper lineHeight="20px" fontStyle="normal" fontSize={"0.875rem"} bold fontFamily>
                  {t("Address")}
                </Wrapper>
                <Wrapper
                  lineHeight="20px"
                  fontStyle="normal"
                  fontSize={"0.875rem"}
                  size="large"
                  marginTop={"0.25rem"}
                  overFlowWrap={"anywhere"}
                  fontFamily
                >
                  {billingAddress}
                </Wrapper>
              </FlexColumn>
            </FlexRow>
          </Wrapper>
        </>
      )}
    </AccountProfile>
  );
}

ManagePrimaryAccount.propTypes = {
  accountId: PropTypes.string,
  accountNumber: PropTypes.string,
  title: PropTypes.string,
};

const mapDispatchToProps = {
  getBannerMessage: GlobalActions.getBannerMessage,
};
const mapStateToProps = (state) => {
  return {
    accountId: state.ACCOUNT.account_id,
    userLanguage: state.ACCOUNT.userLanguage,
    accountProfilePermission: state.ACCOUNT.accountProfilePermission,
    bannerDisplayOnLanding: state.ACCOUNT.bannerDisplayOnAll,
    accountNumber: state.ACCOUNT.accountNumber,
    windowSize: state.ACCOUNT.windowSize,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ManagePrimaryAccount);
